interface ActionButton {
  action: string;
  title: string;
  params: {
    amount: number | null;
    url?: string;
    accountId?: number;
    accountType?: string;
    isChangeService?: boolean;
    serviceId?: number;
  };
}

export interface PushNotificationsData {
  current_page: number;
  data: PushNotification[];
  prev_page_url: string | null;
  next_page_url: string | null;
}

export interface PushNotification {
  id: number;
  Title: string;
  Message: string;
  Image: string | null;
  ExternalLink: string | null;
  Data: null;
  ExpiredDate: string | null;
  CreateDate: string | null;
  UpdateDate: string | null;
  ReadDate: null | string;
  ButtonName: string;
  Button: ActionButton | null;
  Action: string;
}

export interface NotificationsApi {
  getMessages: (_: string) => void;
  pushNotifications: PushNotification[] | undefined;
  isNotificationsLoading: boolean;
  nextPageUrl: string | null;
  prevPageUrl: string | null;
}

export enum ActionTypes {
  OPEN_LINK = 'open_link',
  OPEN_DOCUMENT = 'open_document',
  PAY_SERVICE = 'pay_service',
  PAYMENTS_HISTORY = 'open_payments_history_page',
  TOP_UP = 'top_up',
}
